import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";



@observer
export default class AddressPlacesList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = 'Addres places';
  static icon = 'fa-envelope-o';
  static rootPage = true;
  static protectedPage = 'partyDetail';


  static fetchData(routerParams) {
    console.log("AddressPlacesList#fetchData(%s)");
    return Promise.resolve(null);
  }





  render() {
    let {params, query} = this.props;

    return (
      <div>"Address places list"</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/party/page/addressPlacestList.tsx